import { mapStrings } from "../../lib/frTypo";

/**
 * "Même reco, deux fins" reel — on-screen copy, FR only for now.
 *
 * Sources (landing, packages/landing/src/i18n/locales/fr.json):
 *   - end line  → vs.bothSides.title "… Frak paie les deux."
 *   - end sub   → vs.cta.consumers.body "gagnez de l'argent, et vos
 *                 ami·e·s touchent aussi du cash-back"
 *   - "du cashback" for the buyer → faq.a4
 *   - footnote  → B2C unpaid.footnote; the gain is an example inside the
 *                 live brands' rewards (5–30 € per sale)
 * B2C house style: tutoiement, no em dashes.
 */
export const SPLIT = mapStrings({
  title: "Même reco, deux fins.",
  setup: "Tu recommandes un sérum à ta sœur.",
  without: "SANS FRAK",
  with: "AVEC",
  send: "Je te l'envoie 👇",
  buy: "Elle achète.",
  you: "Toi",
  her: "Elle",
  zero: "0 €",
  cashback: "du cashback",
  thanks: "Merci 🙏",
  note: "Exemple. Le montant dépend de la marque.",
  end: {
    line: "Frak paie les deux.",
    sub: "Du cash pour toi, du cashback pour tes proches.",
  },
});

/** Example gain for the recommender (€), shown with `note`. */
export const SPLIT_GAIN = 6;
